import { FC } from 'react';
import {
  Box,
  Container,
  Divider,
  Flex,
  Heading,
  Icon,
  StackDivider,
  VStack,
} from '@chakra-ui/react';
import { FarmTeaser } from '../../Teaser/FarmTeaser';
import { FarmFragment, FarmTeaserFragment } from '../../../generated/types';
import { IoChevronForward } from '@react-icons/all-files/io5/IoChevronForward';
import Link from 'next/link';

interface FarmNearPremiumFarmsProps {
  data: FarmFragment;
}

export const FarmNearPremiumFarms: FC<FarmNearPremiumFarmsProps> = ({
  data,
}) => {
  if (!data.nearPremiumFarms?.items?.length) {
    return null;
  }

  return (
    <>
      <Box>
        <Container maxW="container.main" py={6}>
          <Heading
            fontFamily="body"
            as="h3"
            fontSize="2xl"
            color="primary"
            fontWeight="bold"
          >
            Trabland Premium Partner in der Nähe
          </Heading>
        </Container>
      </Box>
      <Container
        maxW="container.main"
        py={6}
        borderTop="1px solid"
        borderTopColor="gray.300"
      >
        <VStack
          alignItems="flex-start"
          spacing={9}
          divider={<StackDivider borderColor="gray.300" />}
        >
          {data.nearPremiumFarms?.items.map((farm) => (
            <FarmTeaser data={farm} key={farm.id} />
          ))}
        </VStack>

        <Divider my={6} />

        <Flex justifyContent="center">
          <Link href="/mediadaten" passHref>
            <Box
              width={{
                base: '100%',
                md: 'auto',
              }}
              justifyContent={{
                base: 'center',
                md: 'flex-start',
              }}
              as="a"
              layerStyle="link_button_blue"
              fontSize={{
                base: 'sm',
                md: 'md',
              }}
            >
              Jetzt Premium Partner werden
              <Icon ml={1} as={IoChevronForward} />
            </Box>
          </Link>
        </Flex>
      </Container>
    </>
  );
};
